"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Table = exports.Slide = exports.Row = exports.LayoutOptions = void 0;

var _pptxgenjs = _interopRequireDefault(require("pptxgenjs"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

var LayoutOptions;
exports.LayoutOptions = LayoutOptions;

(function (LayoutOptions) {
  LayoutOptions["standard"] = "LAYOUT_4x3";
})(LayoutOptions || (exports.LayoutOptions = LayoutOptions = {}));

function isImageData(img) {
  return !!img.data;
} // images


var Row = /*#__PURE__*/function () {
  function Row() {
    _classCallCheck(this, Row);

    this.cells = [];
  }

  _createClass(Row, [{
    key: "withCell",
    value: function withCell(cellCreator) {
      var cell = cellCreator();
      this.cells.push(cell);
      return this;
    }
  }, {
    key: "getCells",
    value: function getCells() {
      return _toConsumableArray(this.cells);
    }
  }]);

  return Row;
}();

exports.Row = Row;

var Table = /*#__PURE__*/function () {
  function Table() {
    _classCallCheck(this, Table);

    this.rows = [];
  }

  _createClass(Table, [{
    key: "withRow",
    value: function withRow(rowCreator) {
      var row = rowCreator(new Row());
      this.rows.push(row);
      return this;
    }
  }, {
    key: "getRows",
    value: function getRows() {
      // TODO: Fix this cast
      return this.rows.map(function (r) {
        return _toConsumableArray(r.getCells());
      });
    }
  }]);

  return Table;
}();

exports.Table = Table;

var Slide = /*#__PURE__*/function () {
  function Slide(slideJs, shapes, chartTypes) {
    _classCallCheck(this, Slide);

    this.slideJs = slideJs;
    this.shapes = shapes;
    this.chartTypes = chartTypes;
  }

  _createClass(Slide, [{
    key: "withText",
    value: function withText(text) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.slideJs.addText(text, options);
      return this;
    }
  }, {
    key: "withImage",
    value: function withImage(imageOptions) {
      if (isImageData(imageOptions) && !imageOptions.data.match(/data:image\/(png|jpg|jpeg|gif);base64,/)) {
        throw new Error('Data must be a base64 string');
      }

      this.slideJs.addImage(imageOptions);
      return this;
    }
  }, {
    key: "withShape",
    value: function withShape(shapeType, options) {
      this.slideJs.addShape(this.shapes[shapeType], options);
      return this;
    }
  }, {
    key: "withTable",
    value: function withTable(tableCreator, options) {
      var table = tableCreator(new Table());
      var rows = table.getRows();
      this.slideJs.addTable(rows, _objectSpread({}, options));
      return this;
    }
  }, {
    key: "withChart",
    value: function withChart(type, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.slideJs.addChart(this.chartTypes[type], data, options);
      return this;
    }
  }]);

  return Slide;
}();

exports.Slide = Slide;

var PresentationExport = /*#__PURE__*/function () {
  // TODO: find a better way to test without exposing the internals
  function PresentationExport() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      layout: LayoutOptions.standard
    };

    _classCallCheck(this, PresentationExport);

    this.pptx = new _pptxgenjs.default();
    this.slides = [];
    this.pptx.layout = options.layout;

    if (options.author) {
      this.pptx.author = options.author;
    }

    if (options.company) {
      this.pptx.company = options.company;
    }

    if (options.revision) {
      this.pptx.revision = options.revision;
    }

    if (options.subject) {
      this.pptx.subject = options.subject;
    }

    if (options.title) {
      this.pptx.title = options.title;
    }
  }

  _createClass(PresentationExport, [{
    key: "withSlide",
    value: function withSlide(slideCreator) {
      var pptxGenSlide = this.pptx.addSlide(); // TODO: remove as any when new upgrading to newer version of PptxGenJS

      var slide = new Slide(pptxGenSlide, this.pptx.shapes, this.pptx.charts);
      this.slides.push(slideCreator(slide));
      return this;
    }
  }, {
    key: "save",
    value: function save(fileName) {
      this.pptx.writeFile({
        fileName: fileName
      });
    }
  }]);

  return PresentationExport;
}();

exports.default = PresentationExport;